document.addEventListener('DOMContentLoaded', () => {
  const setupFileInput = (
    inputName: string,
    displayId: string,
    defaultText: string
  ) => {
    const input = document.querySelector(
      `input[name="${inputName}"]`
    ) as HTMLInputElement | null;
    const fileNameDisplay = document.getElementById(
      displayId
    ) as HTMLElement | null;

    if (input && fileNameDisplay) {
      input.addEventListener('change', () => {
        const files = input.files;
        const fileName =
          files && files.length > 0 ? files[0].name : defaultText;
        fileNameDisplay.textContent = fileName;
      });
    }
  };

  setupFileInput('your-cv', 'cv-file-name', 'Votre CV (PDF, 30Mo max)');
  setupFileInput(
    'your-motivation',
    'motivation-file-name',
    'Votre lettre de motivation (PDF, 30Mo max)'
  );
  setupFileInput(
    'your-other',
    'other-file-name',
    'Un autre élément (PDF, 30Mo max)'
  );
});

document.addEventListener(
  'wpcf7submit',
  function (event) {
    const cvFileNameDisplay = document.getElementById('cv-file-name');
    if (cvFileNameDisplay) {
      cvFileNameDisplay.textContent = 'Votre CV';
    }

    const motivationFileNameDisplay = document.getElementById(
      'motivation-file-name'
    );
    if (motivationFileNameDisplay) {
      motivationFileNameDisplay.textContent = 'Votre lettre de motivation';
    }

    const otherFileNameDisplay = document.getElementById('other-file-name');
    if (otherFileNameDisplay) {
      otherFileNameDisplay.textContent =
        'Un autre élément à partager ? (facultatif)';
    }
  },
  false
);
